import styled from 'styled-components';
import { Button } from 'components';
import { Alert } from '@brokerbay/design-components';

export const Divider = styled.hr`
  height: 0;
  border: 1px solid #f0f0f0;
  margin: 0 0 24px 0;
  align-self: stretch;
`;

export const LinkButton = styled(Button).attrs({
  type: 'link',
})`
  font-weight: 400;
  padding-left: 0;
  padding-right: 0;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledAlert = styled(Alert)`
  margin-bottom: 16px;
`;

export const AlertRightItems = styled.span`
  display: flex;
  flex-flow: row nowrap;

  & > button {
    margin-left: 16px;
    padding-top: 0;
    padding-bottom: 0;
    height: 22px;
  }
`;

export const StyledSwitchGrid = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 20px 10px;
  margin: 20px 0px;
`;
